import { RouteConfig } from 'vue-router';

import LoginPage from '@/pages/login/Login.vue';

export const loginRoute: RouteConfig = {
  component: LoginPage,
  name: 'login',
  path: '/login',
};
